// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 459) return "static/chunks/459-ef3f914476d652b5.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"134":"ca465714","249":"990a3170","341":"bc40be6b"}[chunkId] || chunkId) + "." + {"134":"71328ad2bd2a83db","249":"f6598316c3a56fe3","341":"9b7b387d50b361a9","414":"8c111d68c11d4371","833":"de73823ee03273ae","988":"dcb837cd9af33844"}[chunkId] + ".js";
};